import script from "./currentAssetInventories.vue?vue&type=script&setup=true&lang=js"
export * from "./currentAssetInventories.vue?vue&type=script&setup=true&lang=js"

import "./currentAssetInventories.vue?vue&type=style&index=0&id=3e1aca6e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e1aca6e"]])

export default __exports__